import React, { Component } from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';

import ViewEvent from '../../components/exports/ViewEvent';
import { renderCheckOutWithContext, renderVisitedPeopleWithContext } from '../../utilities/Events.js'
import { hideElementForNonAdminsAndNonManagers } from '../../utilities/Forms.js'
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SlidingPane from "../../components/shared/ScrollableSlidingPane";
import ArrivalsForm from '../../forms/Arrivals';
import { request, handleRequestErrors } from '../../helpers/Requests'

class PersonEvents extends Component {

  constructor(props) {
    super(props);

    this.handleEventPanel = this.handleEventPanel.bind(this);
    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
  }

  state = {
    events: [],

    eventPanelToggle: false,
    newPanelToggle: false,
    eventId: null,
    loaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleEventPanel(event) {
    let id = event.currentTarget.id;

    this.setState({
      eventId: id,
      eventPanelToggle: true
    });
    this.props.history.push(`/people/${this.props.person_id}/events/${id}`)
  }

  handleNewPanel(event) {
    this.setState({newPanelToggle: true});
  }

  closePanel() {
    this.setState({
      eventPanelToggle: false,
      eventId: null,
      newPanelToggle: false
    });
    this.props.history.push(`/people/${this.props.person_id}`);

    this.componentDidMount();
  }

  emptyEvents() {
    if (this.state.events.length === 0) {
      return (
        <div className="long-tr">
          <div className="long-td">
            There are no events over the last 7 days.
          </div>
        </div>
      )
    }
  }

  render() {
    const { events, loaded, unauthorized, error } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return (
        <div>
          {error["errors"].map((errors, index) => (
            <div className="warning-box" key={index}>{errors}</div>
          ))}
        </div>
      )
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      let person_id = this.props.person_id;

      const showServices = events.length > 0 && events[0].service_id !== undefined

      return (
        <div>
          <h3 className="inline-block">Recent Events</h3>

          <Link to={`#`} onClick={this.handleNewPanel}>
            <div className={`button new-button ${hideElementForNonAdminsAndNonManagers()}`}>New Arrival</div>
          </Link>

          <div className="table big-table" data-testid="table">
            <div className="tr heading">
              <div className="th">Arrived</div>
              <div className="th">Left</div>
              <div className="th">Location</div>
              { showServices && <div className="th">Service</div> }
              <div className="th">Visited People</div>
              <div className="th">Photo Taken?</div>
            </div>
            {events.map((event) => (
              <Link to={`/people/${person_id}/events/${event.id}`} onClick={this.handleEventPanel} id={event.id} key={event.id} className="tr event">
                <div className="td">{event.check_in}</div>
                {renderCheckOutWithContext(event)}
                <div className="td">{event.location}</div>
                { showServices && <div className="td">{event.service_name || "N/A"}</div> }
                {renderVisitedPeopleWithContext(event)}
                <div className="td center">{event.photo_taken ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faTimes} />}</div>
              </Link>
            ))}
          </div>
          {this.emptyEvents()}

          <Link to={`/exports/events/?search=${this.props.person_name}`} className="centered button hidden-link">Click here to show all events</Link>

          <SlidingPane isOpen={this.state.eventPanelToggle} title="View Event" width="55%"
            onRequestClose={() => { this.closePanel() }}>
            <ViewEvent id={this.state.eventId} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.newPanelToggle} title="New Manual Arrival" width="55%"
            onRequestClose={() => { this.closePanel() }}>
            <ArrivalsForm person_id={person_id} locations={this.props.locations} closePanel={this.closePanel} person_name={this.props.person_name} />
          </SlidingPane>
        </div>
      );
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (state.eventPanelToggle && props.match.params.event_id === undefined) {
      return {
        eventPanelToggle: false
      }
    }
    else if (state.eventPanelToggle && props.match.params.event_id !== state.eventId) {
      return {
        eventId: props.match.params.event_id,
        key: Math.random()
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.match.params.event_id === undefined) {
      return {
        eventPanelToggle: false,
        eventId: null
      }
    }
    else if (props.history.action === "POP" && props.match.params.event_id !== undefined) {
      return {
        eventPanelToggle: true,
        eventId: props.match.params.event_id
      }
    }
    else {
      return null
    }
  }

  componentDidMount() {
    let person_id = this.props.person_id;

    request("GET", `/v1/a/people/${person_id}/events`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ events: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default withRouter(PersonEvents);
